import styled from 'styled-components';

export const Button = styled.button`
    background: #dc882d;
    color: #fff;
    border: none;
    border-radius:0;
    font-size:1.5em;
    padding: 10px 20px;
    box-shadow:3px 3px 3px #000;
    cursor: pointer;
    transition: background .5s;
    font-family: 'New Tegomin', serif;

    &:hover{
        background: #332c36;
    }
`;